export const NoData = () => {
  return <p className="message red">沒有資料。</p>;
}

export default NoData;